import React from 'react';
import { Icon } from 'semantic-ui-react';
import './dots.css';

const Dots = (props) => {
  const dots = props.dots;
  return (
    <span className='dots-space'>
      {dots >= 1 ? <Icon color='black' name='circle' fitted /> : <Icon name='circle'  fitted color='gray-dot' />}
      {dots >= 2 ? <Icon color='black' name='circle' fitted /> : <Icon name='circle'  fitted color='gray-dot' />}
      {dots >= 3 ? <Icon color='black' name='circle' fitted /> : <Icon name='circle'  fitted color='gray-dot' />}
      {dots >= 4 ? <Icon color='black' name='circle' fitted /> : <Icon name='circle'  fitted color='gray-dot' />}
      {dots >= 5 ? <Icon color='black' name='circle' fitted /> : <Icon name='circle'  fitted color='gray-dot' />}
    </span>
  );
};

export default Dots;



// WEBPACK FOOTER //
// ./src/components/dots/Dots.js